import type { WikiArticle } from './wikiTypes'
import { llrArticles } from './wikiArticlesLLR'
import { gfoArticles } from './wikiArticlesGFO'
import { areArticles } from './wikiArticlesARE'
import { sdiArticles } from './wikiArticlesSDI'
import { adminArticles } from './wikiArticlesAdmin'

export const allWikiArticles: WikiArticle[] = [
  ...llrArticles,
  ...gfoArticles,
  ...areArticles,
  ...sdiArticles,
  ...adminArticles,
]

export function getArticleById(id: string): WikiArticle | undefined {
  return allWikiArticles.find((a) => a.id === id)
}

export function getArticlesByCategory(categoryId: string): WikiArticle[] {
  return allWikiArticles.filter((a) => a.categoryId === categoryId)
}
